/**
 * Navamsa (D9) sign index — classical divisional chart dividing each of the
 * 12 Rashis into 9 equal parts of 3°20' (10/3°) each, 108 divisions total
 * across the zodiac.
 *
 * The classical rule assigns each 108th to a sign following the "trine"
 * pattern: movable signs (Aries/Cancer/Libra/Capricorn) start their
 * Navamsa count from themselves, fixed signs (Taurus/Leo/Scorpio/Aquarius)
 * start from the 9th sign from themselves, and dual signs
 * (Gemini/Virgo/Sagittarius/Pisces) start from the 5th sign from
 * themselves. Equivalently — and this is the form implemented below,
 * because it needs no per-sign lookup table — the Navamsa sign index is
 * simply a continuous, unbroken count of 3°20' divisions around the entire
 * 360° zodiac, wrapping every 12 divisions: this reproduces the same
 * classical starting points (e.g. Taurus's Navamsa sequence starts at
 * Capricorn) as a direct consequence of 108 / 12 = 9 dividing evenly, and
 * is the standard implementation used by open-source Vedic astrology
 * calculators (e.g. see PyJHora, jhora.js, and other Parashari-system
 * implementations of `navamsa()`/D9).
 */
export function navamsaSignIndex(siderealLongitudeDeg: number): number {
  const NAVAMSA_SPAN_DEG = 10 / 3; // 3°20'
  const normalized = ((siderealLongitudeDeg % 360) + 360) % 360;
  const division = Math.floor(normalized / NAVAMSA_SPAN_DEG);
  return division % 12;
}
